import React from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  TablePagination,
  Paper,
  Typography,
} from "@mui/material";
import { rowsPerPage } from "../../settings/appConfig";
import Styles from "../Locations/Styles/ListCustodiansStyles";
import AssociateCustodianTableRow from "./AssociateCustodianTableRow";
import { EntityRelationship } from "../../Models/custodian/mapsSearchResult";

export default function AssociationListCards({
  entityRelationships,
  count,
  onPageChanged,
  isLoading,
  pageNo,
  setPageNo,
  usePagination,
  showNoRecordsFoundMessage,
}: {
  count: number;
  entityRelationships: EntityRelationship[];
  onPageChanged?: (_: number) => void;
  isLoading: boolean;
  pageNo: number;
  setPageNo?: React.Dispatch<React.SetStateAction<number>>;
  usePagination: boolean;
  showNoRecordsFoundMessage: boolean;
}) {

  const handlePageChange = (event: unknown, newPage: number) => {
    if (onPageChanged) onPageChanged(newPage);
    if (setPageNo) setPageNo(newPage);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Paper elevation={3} sx={{ p: 2, borderRadius: 3, boxShadow: 2 }}>
        <Table
          size="small"
          sx={{
            width: "100%",
            borderCollapse: "collapse",
            "& td, & th": { border: "none" },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Entity</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>State</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Order Type</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Provider</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>From</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>To</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Link Status</TableCell>
            </TableRow>
          </TableHead>

          {entityRelationships?.map((custodianRow, index) => (
            <AssociateCustodianTableRow key={custodianRow.entityId} custodianRow={custodianRow} facilityIndex={index} />
          ))}
        </Table>

        {!entityRelationships || entityRelationships?.length === 0 ? (
          <Box sx={Styles.loaderStyles} mt={2}>
            {isLoading ? (
              <CircularProgress />
            ) : showNoRecordsFoundMessage ? (
              <Typography variant="h6">No records found</Typography>
            ) : null}
          </Box>
        ) : null}

        {usePagination && (
          <TablePagination
            component="div"
            sx={Styles.paginationStyles}
            labelRowsPerPage={"Items per page:"}
            showFirstButton
            showLastButton
            count={count}
            page={pageNo}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[]}
          />
        )}
      </Paper>
    </Box>
  );
}
